import { render, staticRenderFns } from "./DirfsDash.vue?vue&type=template&id=1639e6ea&"
import script from "./DirfsDash.vue?vue&type=script&lang=js&"
export * from "./DirfsDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports